import { render, staticRenderFns } from "./InstagramIcon.vue?vue&type=template&id=0b502e02&"
import script from "./InstagramIcon.vue?vue&type=script&lang=js&"
export * from "./InstagramIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports